import type { FlexProps } from "@qws-org/ui-kit";
import { Flex, Image, Title } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { TextHighlighterData } from "~/core";
import type { ImageParams } from "~/shared/utils/directus/useDirectus";

export type TextHighlighterProps = {
  data: TextHighlighterData;
  getImageUrl: (imageId: string, params?: ImageParams) => string;
} & FlexProps;

export const TextHighlighter: FC<TextHighlighterProps> = ({
  data,
  getImageUrl,
  ...rest
}) => {
  return (
    <Flex
      bg={
        data.backgroundImage
          ? getImageUrl(data.backgroundImage.id, {
              format: "webp",
              height: 400,
            })
          : (data.backgroundColor ?? "")
      }
      p={{ py: 32, px: 16 }}
      {...rest}
      md={{
        p: { py: 40 },
        ...rest.md,
      }}
    >
      <Flex
        flexDirection="column"
        align="center"
        justify="center"
        gap={24}
        maxWidth={1240}
        m={{ mx: "auto" }}
        md={{
          gap: 40,
          flexDirection: "row",
          ...rest.md,
        }}
      >
        {data?.icon?.id && (
          <Image
            width={32}
            md={{ width: 48 }}
            value={getImageUrl(data.icon.id, {
              format: "webp",
              width: 48,
            })}
          />
        )}
        <Title
          fontWeight="mobile.semibold"
          size="small"
          horizontalAlign="center"
          md={{
            fontSize: "title.desktop.medium",
            lineHeight: "title.desktop.medium",
          }}
        >
          {data.title}
        </Title>
        {data?.icon?.id && (
          <Image
            width={32}
            md={{ width: 48 }}
            value={getImageUrl(data.icon.id, {
              format: "webp",
              width: 48,
            })}
          />
        )}
      </Flex>
    </Flex>
  );
};
